import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api';

export const getTagsForPerson = createAsyncThunk(
	'getTagsForPerson',
	async (_, { rejectWithValue }) => {
		const params = { is_for_persons: true };
		return await thunkAxiosRequest({
			path: `/api/v1/tags`,
			params,
			abortWithParams: true,
			rejectWithValue,
		});
	},
);

export const getTagsForOrder = createAsyncThunk(
	'getTagsForOrder',
	async (_, { rejectWithValue }) => {
		const params = { is_for_orders: true };
		return await thunkAxiosRequest({
			path: `/api/v1/tags`,
			params,
			abortWithParams: true,
			rejectWithValue,
		});
	},
);
